import React, {useState} from 'react';
import AdhocImageGallary from "../AdhocImageGallary";
import AdhocImageUpload from "../AdhocImageUpload";
import {Button} from "react-bootstrap";

const issueLabelMap = {
    'fix': 'Property Require Maintenance',
    'clean': 'Property Require Deep Clean',
    'key': 'Property Key Missing'
};

const IssueResolveForm = (props) => {
    const {issue, activeJob, fulfillResolve} = props;

    const [formData, setFormData] = useState({
        cos_job_id: activeJob.cos_job_id,
        property_id: activeJob.property_id,
        category: 'fix',
        type: '',
        resolve_description: '',
        resolve_images: [],
        id: issue.id
    });

    const issueLabel = issueLabelMap[formData.category];

    const addImage = (images) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            resolve_images: [...prevFormData.resolve_images, ...images]
        }));
    };

    const handleSave = () => {
        const updatedFormData = {
            ...formData,
            action: 'resolve',
            resolve_image_ids: formData.resolve_images?.map(image => image.id)
        };
        setFormData(updatedFormData);
        fulfillResolve(updatedFormData);
    };

    const handleDescriptionChange = (text) => {
        setFormData({...formData, resolve_description: text});
    };

    return (
        <>
            <div className="card">
                <div style={{margin: "15px"}}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <h2>Issue to Resolve: {issueLabel}</h2>
                    </div>
                    <label style={{fontWeight: '800', fontSize: '14px', marginTop: '15px', marginBottom: '15px'}}>Resolution
                        Description:</label>
                    <textarea
                        placeholder="Enter your resolution Description here"
                        style={{marginTop: '8px', height: '30px', width: '100%'}}
                        value={formData.resolve_description}
                        onChange={(e) => handleDescriptionChange(e.target.value)}
                    />

                    <label style={{fontWeight: '800', fontSize: '14px', marginTop: '15px'}}>Issue Photos:</label>
                    <AdhocImageGallary images={issue.images} isReadOnly={true}
                    />
                    <label style={{fontWeight: '800', fontSize: '14px', marginTop: '15px'}}>Resolution Images:</label>
                    <AdhocImageGallary
                        images={formData.resolve_images}
                        setImages={(newImages) => setFormData({...formData, resolve_images: newImages})}
                    />
                </div>

                <div className="card-actions">
                    <AdhocImageUpload images={formData.resolve_images} setImages={addImage}/>
                    <Button
                        style={{padding: '10px', margin: '10px'}}
                        disabled={formData.resolve_images.length === 0}
                        onClick={handleSave}
                    >
                        Resolve Issue
                    </Button>
                </div>
            </div>
        </>
    );
};

export default IssueResolveForm;
